import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Clique no push do navegador com o painel aberto: o /sw.js manda
 * `wedrop:open-notification` para a aba e a navegação acontece aqui, sem
 * recarregar. Sem aba aberta o próprio SW abre a URL.
 */
export function PushClickBridge() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return
    const aoMensagem = (evento: MessageEvent) => {
      const dados = evento.data
      if (dados?.type !== 'wedrop:open-notification') return
      if (typeof dados.url === 'string' && dados.url.startsWith('/'))
        navigate(dados.url)
    }
    navigator.serviceWorker.addEventListener('message', aoMensagem)
    return () =>
      navigator.serviceWorker.removeEventListener('message', aoMensagem)
  }, [navigate])

  return null
}
